import { FormattedMessage, useIntl } from 'react-intl';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import { P } from '@osmosis/tailwind-ui/components/Text';
import { Icon } from '@osmosis/tailwind-ui/components/Icon';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import { text4 } from '@osmosis/tailwind-ui/styles/text';
import DashboardSearchTips from './DashboardSearchTips';

type Props = Readonly<{
  isAiChatMode: boolean;
}>;

/**
 * Subtext shown below the hero input in the new Search/AI Chat
 */
const DashboardSearchModeSubtext = ({ isAiChatMode }: Props) => {
  const intl = useIntl();

  return (
    <Flex
      data-testid="dashboard-search-mode-subtext"
      className={cn(
        'my-2 gap-2 self-start text-base font-bold leading-none',
        isAiChatMode ? 'items-center' : 'flex-col items-start',
        text4,
      )}
    >
      {isAiChatMode ? (
        <>
          <Flex className="items-center gap-1.5">
            <Icon icon={faShieldCheck} className={text4} size={16} />
            <FormattedMessage
              id="dashboard.welcomeHeader.trustElsevier"
              defaultMessage="Grounded in trusted Elsevier medical content"
            />
          </Flex>
          <span aria-hidden="true">
            {intl.formatMessage({
              id: 'dashboard.welcomeHeader.trustSeparator',
              defaultMessage: '•',
            })}
          </span>
          <Flex className="items-center gap-1.5">
            <Icon icon={faVideo} className={text4} size={16} />
            <FormattedMessage
              id="dashboard.welcomeHeader.trustOsmosis"
              defaultMessage="Connected to Osmosis videos"
            />
          </Flex>
        </>
      ) : (
        <Flex className="flex-col items-start">
          <P className={cn('!text-base font-bold leading-none', text4)}>
            <FormattedMessage
              id="dashboard.search.subtext"
              defaultMessage="Search for a topic. Then learn it faster."
            />
          </P>
          <DashboardSearchTips
            classNames={{
              iconClassNames: {
                diabetes: 'w-[18px] h-3.5 mr-1',
              },
              tipText: '!text-sm font-normal leading-none',
            }}
          />
        </Flex>
      )}
    </Flex>
  );
};

export default DashboardSearchModeSubtext;
